import { Component, OnInit } from '@angular/core';
import { IVariazioneRisposta } from '../interfaces/IVariazioneRisposta';
import { AccessiService } from '../services/accessi.service';
import { RequestBuilder } from '../classes/request-builder';
import { AlertUtil } from '../utils/alert-util';
import { IVariazioneAccesso } from '../interfaces/IVariazioneAccesso';
import * as Enum from '../utils/enums'
import { Loading } from '../utils/loading';
import { DocumentiService } from '../services/documenti.service';
import { finalize } from 'rxjs/operators';
import * as Constants from '../utils/constants';
import { IDocumento } from '../interfaces/IDocumento';
import { IStoricoRisposte } from '../interfaces/IStoricoRisposte';
import { DocumentoPrefettoModalComponent } from '../documento-prefetto-modal/documento-prefetto-modal.component';
import { DocumentoModalComponent } from '../documento-modal/documento-modal.component';
import { DialogService } from 'primeng/api';
import { StoricoModuloService } from '../services/storicomodulo.service';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent implements OnInit {

  variazioneRisposte: IVariazioneRisposta[]
  variazioneAccessi: IVariazioneAccesso[]

  variazioneRispostaSelected: IVariazioneRisposta
  documentoSelected: IDocumento
  isPrefetto: boolean

  DTT = Enum.DATA_TABLE_TYPE_ENUM //export enum for html

  constructor(private documentiService: DocumentiService, private accessiService: AccessiService, private alertUtil: AlertUtil, private dialogService: DialogService, private storicoModuloService: StoricoModuloService) {
    let userRole = localStorage.getItem(Constants.LS_USER_ROLE)
    this.isPrefetto = userRole == Enum.USER_TYPE_ENUM.PREFETTURA || userRole == Enum.USER_TYPE_ENUM.DL
  }

  ngOnInit() {
    setTimeout(() => {
      this.getVariazioniRisposte()
    }, 0);
  }

  /**
   * fill pane based on tab selected
   * @param changeEvent 
   */
  onChangeTab(changeEvent) {
    // index = 0 is Doc tab
    if (changeEvent.index == 0) {
      this.getVariazioniRisposte()
    }
    else if (changeEvent.index == 1) {
      // index = 1 is Accessi tab
      this.getVariazioniAccessi()
    }
  }

  /**
   * get all variazioni documenti
   */
  getVariazioniRisposte() {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder()
    this.documentiService.fetchVariazioniRisposte(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(response => {
      if (response.data) {
        this.variazioneRisposte = response.data
      }
      else if (response.error) {
        let errorKey = "LBL_ERROR_" + response.error.Code
        this.alertUtil.showErrorAlert(errorKey)
        console.log("ERROR: " + response.error.Stack)
      }
      else {
        this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
      }
    }, error => {
      let errorKey = "LBL_HTTP_ERROR_0"
      if (error.status) {
        errorKey = "LBL_HTTP_ERROR_" + error.status
      }
      this.alertUtil.showErrorAlert(errorKey)
    })
  }

  /**
   * get all variazioni accessi
   */
  getVariazioniAccessi() {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder({ Id: -1 })
    this.accessiService.fetchVariazioneAccessi(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(response => {
      if (response.data) {
        this.variazioneAccessi = response.data
      }
      else if (response.error) {
        let errorKey = "LBL_ERROR_" + response.error.Code
        this.alertUtil.showErrorAlert(errorKey)
        console.log("ERROR: " + response.error.Stack)
      }
      else {
        this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
      }
    }, error => {
      let errorKey = "LBL_HTTP_ERROR_0"
      if (error.status) {
        errorKey = "LBL_HTTP_ERROR_" + error.status
      }
      this.alertUtil.showErrorAlert(errorKey)
    })
  }

  /**
   * row selected
   * @param variazioneRisposta obj selected
   */
  onVariazioneRispostaRowSelected(variazioneRisposta: IVariazioneRisposta) {
    this.variazioneRispostaSelected = variazioneRisposta
    this.callStoricoModuloFetchSingle(this.variazioneRispostaSelected.Versione_modulo)
  }

   /**
   * row unselected
   * @param variazioneRisposta obj selected
   */
  onVariazioneRispostaRowUnselected() {
    this.variazioneRispostaSelected = null
  }

  /**
   * call storicoModulo fetch single
   */
  callStoricoModuloFetchSingle(versioneDoc: number) {
    Loading.isLoading = true
    let requestBuilder = new RequestBuilder({
      Id: this.variazioneRispostaSelected.Id_modulo,
      Version: versioneDoc > 0 ? versioneDoc : null
    })
    this.storicoModuloService.storicoModuloFetchSingle(requestBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.documentoSelected = response.data
          this.createCustomResponse()
          if (this.variazioneRispostaSelected) {
            this.checkUserRoleAndOpenModal(versioneDoc > 0 ? versioneDoc : -1)
          }
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * check user role and open modal
   */
  private checkUserRoleAndOpenModal(versioneDoc: number) {
    this.documentoSelected.Versione = versioneDoc
    //if prefetto open specific modal
    if (this.isPrefetto) {
      this.openPrefettoModal(this.documentoSelected)
    }
    else {
      this.openDocumentoModal(this.documentoSelected);
    }
  }

  /**
   * open prefetto modal
   * @param documento 
   */
  openPrefettoModal(documento: IDocumento) {
    let documentoModal = this.dialogService.open(DocumentoPrefettoModalComponent, {
      data: { documento, richiesta: documento.Richiesta },
      header: documento.Nome,
      width: '35%'
    })
    documentoModal.onClose.subscribe((documentoObj) => {
      if (documentoObj) { //force refresh 
        this.variazioneRispostaSelected = null
      }
    })
  }

  /**
   * open documento modal
   * @param documento 
   */
  openDocumentoModal(documento: IDocumento) {
    let documentoModal = this.dialogService.open(DocumentoModalComponent, {
      data: { documento, richiesta: documento.Richiesta, fromFullTextSearch: true, fromAlert: true },
      header: documento.Nome,
      width: '80%'
    })
    documentoModal.onClose.subscribe((documentoObj) => {
      if (documentoObj) { //force refresh 
        this.variazioneRispostaSelected = null
        this.callStoricoModuloFetchSingle(0)
      }
    })
  }

  /**
 * read documento Selected and set Risposta Custom for all questions
 */
  createCustomResponse() {
    let storicoRisposte = this.documentoSelected.StoricoRisposte //get storico risposte array
    let matrDomande = this.documentoSelected.MatriceModulo.MatriceDomande //get matrice domande array
    if (matrDomande) {
      for (let i = 0; i < matrDomande.length; i++) { // iterate matrice domande
        let matriceDomanda = matrDomande[i]
        if (storicoRisposte) {
          for (let y = 0; y < storicoRisposte.length; y++) { // iterate storico risposte
            let storicoRisp = storicoRisposte[y]
            if (storicoRisp.Domanda_Id == matriceDomanda.Id) { // if answer for this question set rispostaCustom to matrice domanda
              matriceDomanda.RispostaCustom = storicoRisp
              break;
            }
          }
          if (!matriceDomanda.RispostaCustom) { // if matrice domanda has no risposta custom set empty risposta
            let storicoEmpty: IStoricoRisposte = {
              Domanda_Id: matriceDomanda.Id,
              Valore: null,
              Placeholder: null,
              Valido: null
            }
            matriceDomanda.RispostaCustom = storicoEmpty
          }
        }
      }
    }
  }
}
